import React, { FC, useCallback, useMemo } from 'react';
import { observer } from "mobx-react-lite";
import settingsButtonBlue from "../../../assets/SettingCogBlue.svg";
import settingsButtonGray from "../../../assets/settings.svg";
import { AppContext } from "../../../App";

export interface ISettingsButtonProps {
    onClickFunc: () => void;
    permission: boolean;
}

const BtnSettings: FC<ISettingsButtonProps> = ({ onClickFunc, permission }) => {
    const { showToast } = React.useContext(AppContext);

    const buttonIcon = useMemo(() => 
        permission ? settingsButtonBlue : settingsButtonGray, 
        [permission]
    );

    const handleClick = useCallback(() => {
        if (permission) {
            onClickFunc();
        } else {
            showToast("У вас нет прав для редактирования канбан-доски!");
        }
    }, [permission, onClickFunc, showToast]);

    return (
        <div className="button-base" onClick={handleClick}>
            <img 
                src={buttonIcon} 
                alt="Settings" 
                title={permission ? "Настройки доски" : "Нет прав доступа"}
            />
        </div>
    );
};

export default observer(BtnSettings);